import React from 'react';
import { MenuItem, Pagination, Select } from '@mui/material';
import {
  gridPageCountSelector,
  gridPageSelector,
  gridPageSizeSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import {
  PageNavigationContainer,
  PaginationContainer,
  RowsPerPageContainer,
  RowsPerPageLabel,
  StyledFormControl,
} from './styled';

export const CustomPagination: React.FC = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    apiRef.current.setPage(value - 1);
  };

  const handlePageSizeChange = (event: { target: { value: unknown } }) => {
    apiRef.current.setPageSize(Number(event.target.value));
  };

  return (
    <PaginationContainer id="pagination-container">
      {/* Rows per page */}
      <RowsPerPageContainer>
        <RowsPerPageLabel variant="body2">Rows per page:</RowsPerPageLabel>
        <StyledFormControl size="small" variant="standard">
          <Select value={pageSize} onChange={handlePageSizeChange}>
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </StyledFormControl>
      </RowsPerPageContainer>

      {/* Page numbers */}
      <PageNavigationContainer id="page-navigation-container">
        <Pagination
          id="page-navigation-container-inner"
          count={pageCount}
          page={page + 1}
          onChange={handlePageChange}
          color="primary"
          variant="outlined"
          shape="rounded"
          size="small"
          siblingCount={0}
          boundaryCount={1}
        />
      </PageNavigationContainer>
    </PaginationContainer>
  );
};
